<template>
  <GlobalWindow
    v-loading="isUploading"
    :title="title"
    :visible.sync="visible"
    :confirm-working="isWorking"
    @confirm="confirm"
  >
    <el-form :model="form" ref="form" :rules="rules" label-width="120px" label-suffix="："  inline>
      <el-form-item label="文章名称" prop="title">
        <el-input v-model="form.title" placeholder="请输入分类名称" v-trim/>
      </el-form-item>
      <el-form-item label="文章分类" prop="labelId">
        <el-select
          v-model="form.labelId"
          filterable
          clearable
          placeholder="请选择文章分类"
        >
          <el-option v-for="item in labels()" :key="item.id" :value="item.id" :label="item.name" />
        </el-select>
      </el-form-item>
      
      <el-form-item label="背景图" prop="imgurlfull">
        <UploadAvatarImage
          :file="{ 'imgurlfull': form.imgFullUrl, 'imgurl': form.imgurl }"
          :uploadData="uploadData"
          @uploadSuccess="uploadAvatarSuccess"
          @uploadEnd="isUploading = false"
          @uploadBegin="isUploading = true"
        />
      </el-form-item>
      <el-form-item label="活动详情" prop="content">
        <RichEditor :content="{ content : form.content}"  @edit="form.content=$event" />
      </el-form-item>
      <el-form-item label="排序码" prop="sortnum">
        <el-input v-model="form.sortnum" placeholder="请输入排序码" v-trim/>
      </el-form-item>
    </el-form>
  </GlobalWindow>
</template>

<script>
import BaseOpera from '@/components/base/BaseOpera'
import GlobalWindow from '@/components/common/GlobalWindow'
import RichEditor from '@/components/common/RichEditor'
import UploadAvatarImage from '@/components/common/UploadAvatarImage'
export default {
  name: 'OperaLabelsWindow',
  extends: BaseOpera,
  components: { GlobalWindow, RichEditor, UploadAvatarImage },
  data () {
    return {
      uploadData: {
        folder: 'activity'
      },
      isUploading: false,
      // 表单数据
      form: {
        id: null,
        title: '',
        labelId: '',
        imgFullUrl: '',
        imgurl: '',
        content: '',
        sortnum: '',
      },
      // 验证规则
      rules: {
      }
    }
  },
  inject: ['labels'],
  created () {
    this.config({
      api: '/business/article',
      'field.id': 'id'
    })
  },
  methods: {
    // 上传图片
    uploadAvatarSuccess(file) {
      this.form.imgurl = file.imgurl;
      this.form.imgFullUrl = file.imgurlfull;
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/style/alertstyle.scss";
::v-deep .el-select {
  width: 100%;
  .el-input__inner {
    width: 100%;
  }
}
</style>
